module.exports = __webpack_public_path__ + "static/img/wb_img_service.5cb3bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/wb_img_service.png
// module id = bv5g
// module chunks = 1